import { useQuery } from '@tanstack/react-query'

import { supportTicketsUnseenCountRetrieveOptions } from 'src/api/main'

export const useTicketActivity = () => {
  const { data } = useQuery({ ...supportTicketsUnseenCountRetrieveOptions() })

  return { ticketsWithSupportReplyCount: data?.count ?? 0 }
}
